import {assertNotNull} from "../../js/util/CommonUtils.js";
import DialogUtils from "../../js/util/DialogUtils.js";

export default class StructureFormSelectorHtml {
    /** @type {HTMLDialogElement} */
    #dialog;
    /** @type {HTMLElement} */
    #listElement;
    /** @type {Function} */
    #onOkCb;
    /** @type {StructureForms} */
    #forms;

    constructor(onOkCb) {
        this.#onOkCb = assertNotNull(onOkCb);
    }

    /** @param {StructureForms} forms */
    show(forms) {
        this.#forms = forms;
        document.body.insertAdjacentHTML('beforeend', this.#template());
        this.#dialog = document.body.lastElementChild;
        this.#dialog.showModal();
        this.#addListeners();
        this.#listElement = this.#dialog.querySelector('.structure-forms-list');
    }

    destroy() {
        this.#dialog.remove();
    }

    /** @returns {{stereo: boolean, protonation: boolean}} */
    getFormsChecked() {
        const result = {}
        for(const c of this.#listElement.children){
            const input = c.querySelector('input');
            const name = input.getAttribute("data-id");
            result[name] = input.checked;
        }
        this.#forms.setSelected(result);
        return result;
    }

    #onOk() {
        this.destroy();
        this.#onOkCb(this.getFormsChecked());
    }

    #addListeners(){
        DialogUtils.setDefaultDialogListeners(this.#dialog);
        this.#dialog.querySelector('.btn-ok').addEventListener('click', this.#onOk.bind(this));
        this.#dialog.querySelector('.btn-cancel').addEventListener('click', this.destroy.bind(this));
        this.#dialog.addEventListener('cancel', this.destroy.bind(this));
    }

    #template() {
        const stereoCheckedAttr =this.#forms.selectedOptions.stereo ? "checked" : "";
        const protonationCheckedAttr =this.#forms.selectedOptions.protonation ? "checked" : "";

        return `
            <dialog class="structure-form-selector__dialog">
                <main class="dialog-content">
                    <ul class="structure-forms-list">
                        <li class="structure-forms-list__item">
                            <label class="structure-forms__item-label" >
                                <input type="checkbox" data-id="stereo" ${stereoCheckedAttr}>
                                Include stereo isomers and tautomers
                            </label>
                        </li>
                        <li class="structure-forms-list__item">
                            <label class="structure-forms__item-label" >
                                <input type="checkbox" data-id="protonation" ${protonationCheckedAttr}>
                                Include other protonation states
                            </label>
                        </li>
                    </ul>
                  </main>
                  <footer class="popup__footer popup__footer--main-buttons-only">
                    <button name="btn-cancel" class="button button--text btn-cancel">Cancel</button>
                    <button name="btn-ok" class="button button--contained btn-ok">Search</button>
                  </footer>
                </dialog>
                `;
    }
}